import { LoaderCircle } from 'lucide-react';
import { type FC } from 'react';

import ReleaseNoteMenuFooter from '@/components/manage-release-notes/release-note-menu-footer';
import ReleaseNoteMenuFooterError from '@/components/manage-release-notes/release-note-menu-footer-error';
import { SheetFooter } from '@/components/ui/sheet';
import useGetReleases from '@/hooks/use-get-releases';

interface BurgerMenuFooterProps {
  onOpenReleaseNotes: () => void;
}

const BurgerMenuFooter: FC<BurgerMenuFooterProps> = ({ onOpenReleaseNotes }) => {
  const { data, isLoading, isError, refetch } = useGetReleases();
  const { releases } = data ?? {};

  let content = null;

  if (isLoading) {
    content = (
      <div className="flex h-full items-center justify-center px-5">
        <LoaderCircle className="size-10 animate-spin text-primary" />
      </div>
    );
  } else if (isError) {
    content = <ReleaseNoteMenuFooterError onRetry={refetch} />;
  } else {
    const currentRelease = releases?.find((release) => release.isCurrent);

    if (currentRelease) {
      content = <ReleaseNoteMenuFooter release={currentRelease} onClick={onOpenReleaseNotes} />;
    }
  }

  if (!content) {
    return null;
  }

  return <SheetFooter className="min-h-14 h-fit border-t p-0 py-2">{content}</SheetFooter>;
};

export default BurgerMenuFooter;
